import { toTypedSchema } from '@vee-validate/zod';
import * as z from 'zod';

export const customShirtFormSchema = toTypedSchema(
	z.object({
		// shirt
		// sleeveLiningLength: z.number({
		// 	required_error: 'You need to enter length.',
		// }),
		wristLength: z.number({
			required_error: 'You need to enter length.',
		}),
		sleeveLength: z.number({
			required_error: 'You need to enter length.',
		}),
		bottomLength: z.number({
			required_error: 'You need to enter length.',
		}),
		hipLength: z.number({
			required_error: 'You need to enter length.',
		}),
		shirtLength: z.number({
			required_error: 'You need to enter length.',
		}),
		shoulderLength: z.number({
			required_error: 'You need to enter length.',
		}),
		chestLength: z.number({
			required_error: 'You need to enter length.',
		}),
		waistLength: z.number({
			required_error: 'You need to enter length.',
		}),
		armHoleLength: z.number({
			required_error: 'You need to enter length.',
		}),
		unitsShirt: z.string(),

		// trouser
		trouserLength: z.number({
			required_error: 'You need to enter length.',
		}),
		trouserWaistLength: z.number({
			required_error: 'You need to enter length.',
		}),
		trouserThighLength: z.number({
			required_error: 'You need to enter length.',
		}),
		trouserKneeLength: z.number({
			required_error: 'You need to enter length.',
		}),
		trouserBottomLength: z.number({
			required_error: 'You need to enter length.',
		}),
		trouserHipLength: z.number({
			required_error: 'You need to enter length.',
		}),
		unitsTrouser: z.string(),
	}),
);

export interface CustomFormTypes {
	wristLength: number;
	sleeveLength: number;
	bottomLength: number;
	hipLength: number;
	shirtLength: number;
	shoulderLength: number;
	chestLength: number;
	waistLength: number;
	armHoleLength: number;

	// trouser
	trouserLength: number;
	trouserWaistLength: number;
	trouserThighLength: number;
	trouserKneeLength: number;
	trouserBottomLength: number;
	trouserHipLength: number;
}
